<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Complaint",
  path: "complaint",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
